/* "Show more" on collection grids (sections/main-collection-product-grid.liquid).
   - Appends the next page in place and writes ?page=N to the URL.
   - Opening a URL with ?page=N (reload, Back from a product) fetches pages 1..N-1 in front of the
     server-rendered page N, so the grid holds everything again, then returns to the scroll position
     the shopper left from. */
(() => {
  const SCROLL_KEY = 'mk-more-scroll:';
  const grid = () => document.getElementById('product-grid');
  const btn = () => document.querySelector('[data-mk-more-button]');

  const pageUrl = (n) => {
    const u = new URL(location.href);
    if (n > 1) u.searchParams.set('page', n); else u.searchParams.delete('page');
    return u;
  };
  const fetchPage = async (n) => {
    const html = await fetch(pageUrl(n).toString()).then((r) => r.text());
    return new DOMParser().parseFromString(html, 'text/html');
  };
  const updateCount = () => {
    const g = grid(); const b = btn(); if (!g) return;
    const shown = g.querySelectorAll(':scope > li:not(.mk-tile-item)').length;
    const total = b ? Number(b.dataset.total) || shown : shown;
    const count = document.querySelector('[data-mk-more-count]');
    if (count) count.textContent = count.textContent.replace(/\d+/, String(shown));
    const bar = document.querySelector('[data-mk-more-bar]');
    if (bar) bar.style.width = `${Math.min(100, (shown / total) * 100)}%`;
  };

  // Show more
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-mk-more-button]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    try {
      const next = Number(new URL(b.href, location.href).searchParams.get('page')) || 2;
      const doc = await fetchPage(next);
      doc.querySelectorAll('#product-grid > li').forEach((li) => grid().appendChild(document.adoptNode(li)));
      history.replaceState(history.state, '', pageUrl(next));
      // Next page: from the fetched page, else computed while products are still missing
      // (a cached or differently rendered response must not end the list early).
      const more = doc.querySelector('[data-mk-more-button]');
      const shown = grid().querySelectorAll(':scope > li:not(.mk-tile-item)').length;
      const total = Number(b.dataset.total) || 0;
      if (more) b.href = more.href;
      else if (total && shown < total && doc.querySelectorAll('#product-grid > li').length) b.href = pageUrl(next + 1).toString();
      else document.querySelector('[data-mk-more]').remove();
      updateCount();
    } catch (err) {
      location.href = b.href;
    } finally {
      b.removeAttribute('aria-busy');
    }
  });

  // Remember where the shopper was when they open a product
  document.addEventListener('click', (e) => {
    if (e.target.closest('#product-grid a[href*="/products/"]')) {
      try { sessionStorage.setItem(SCROLL_KEY + location.pathname + location.search, String(window.scrollY)); } catch (err) {}
    }
  });

  // Restore pages 1..N-1 when landing on ?page=N
  const restore = async () => {
    const n = Number(new URL(location.href).searchParams.get('page')) || 1;
    const g = grid();
    if (n <= 1 || !g || g.dataset.mkRestored) return;
    g.dataset.mkRestored = '1';
    try {
      const docs = await Promise.all(Array.from({ length: n - 1 }, (_, i) => fetchPage(i + 1)));
      const frag = document.createDocumentFragment();
      docs.forEach((doc) => doc.querySelectorAll('#product-grid > li').forEach((li) => frag.appendChild(document.adoptNode(li))));
      g.insertBefore(frag, g.firstChild);
      updateCount();
      let y = null;
      try { y = sessionStorage.getItem(SCROLL_KEY + location.pathname + location.search); } catch (err) {}
      if (y !== null) window.scrollTo(0, Number(y));
    } catch (err) {}
  };
  // With Show more on the page, the numbered pagination is never shown (it stays in the HTML for crawlers).
  const hidePagination = () => { if (document.querySelector('[data-mk-more]')) document.querySelectorAll('.pagination-wrapper').forEach((p) => { p.hidden = true; }); };
  hidePagination();
  document.addEventListener('DOMContentLoaded', hidePagination);
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
})();
